<script>
    import "./unixTiers.css";
    export let tierImage = "./images/tiers1.png";
    let buttonLine = "./images/button-line.png";
    let activeList = false;
    export let tierTitle = "";
</script>
<div class="tier-wrap flex flex-wrap column-direction">
    <h3 class="tier-heading flex flex-text-center items-center">{tierTitle}</h3>
    <div class="tier-content-wrap flex flex-wrap flex-text-center column-direction">
        <figure>
            <img src={tierImage} alt="tier Image">
        </figure>
        <div class="tiers-collapse flex column-direction">
            <button class="collapse-btn flex flex-text-center" on:click={()=> activeList = !activeList}><img src={buttonLine} alt="buttonLine"></button>
            <ul class="flex-wrap" class:activeList>
                <li><span>1000 Tokens</span></li>
                <li><span>700+ Private Allocation</span></li>
                <li><span>Guaranty. Allocation : Yes</span></li>
                <li><span>Early Access Gear & Merch</span></li>
                <li><span>Early Access NFT Drops</span></li>
                <li><span>Early Access Games</span></li>
                <li><span>NFT Treasury Access</span></li>
                <li><span>Private Chat With Founding Team</span></li>
            </ul>
        </div>
    </div>
</div>